import { Section } from "@/components/ui/Section";
import { Col, EntryButton } from "@/components";
import "./Login.scss";
import { Config } from "@/utils/config.ts";

export type LoginProps = {
  title: React.ReactNode;
  description?: React.ReactNode;
  loginTitle: string;
  loginDescription: React.ReactNode;
  buttonLabel: string;
  buttonAriaLabel: string;
  buttonHref: string;
  asImage?: "img";
  region?: Config["REGION"];
  authSrc?: string;
};

export const Login = ({
  title,
  description,
  loginTitle,
  loginDescription,
  buttonLabel,
  buttonAriaLabel,
  buttonHref,
  asImage = "img",
  authSrc = "",
}: LoginProps) => {
  const ImageComponent = asImage;

  return (
    <Section className="base-col ui-login-section">
      <Col className="ui-login-content">
        <Section.Title fs="1" className="md-fs-0 ui-login-title" mdFs="0">
          {title}
        </Section.Title>
        {description && (
          <Section.Description className="ui-login-description">
            {description}
          </Section.Description>
        )}
      </Col>
      <div className="bg-white shadow br-x4 ui-login-body">
        <Col gap={"x16"}>
          <h1 className="text-slate-20 fw-semibold fs-5 md-fs-4">
            {loginTitle}
          </h1>
          <Section.Description>{loginDescription}</Section.Description>
          <EntryButton
            // showIcon={region === "marche"}
            ariaLabel={buttonAriaLabel}
            href={buttonHref}
          >
            {buttonLabel}
          </EntryButton>
        </Col>

        <div className="ui-login-body-img h-full">
          <ImageComponent
            src={authSrc}
            alt=""
            aria-hidden="true"
            width={246}
            height={746}
          />
        </div>
      </div>
    </Section>
  );
};
